function checkPrivacyFlag(form, errorCount, invalidElements) {
  if (invalidElements.some(element => element.id == "privacy" && !element.checked)) {
    showMessageBox("danger", "Devi accettare la privacy policy");
  }
}

function contactRecaptchaCallback() {
  $("#contact-form").get(0).submit();
}